import styled from 'styled-components';
import BasedModal from "components/BaseModalComponents/BasedModal";
import {PlusIcon} from "assets/images";
import {CloseCross} from "assets/images";
import {LightTrashIcon} from "../../../assets/images";


export const Search = styled.input`
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    color: black;
    padding: 8px 10px;
    border-radius: 5px;

    :focus {
        outline: none;
    }
`;

export const List = styled.div`
    display: flex;
    flex-direction: column;
    overflow: auto;
    //padding-right: 12px;
    max-height: 500px;
`;

export const DropTabDiv = styled.div<{isActive?: boolean}>`
    border-bottom: solid 1px;
    border-color: ${(props) => props.theme.color.lightGreen};
    cursor: pointer;
    transition: 0.2s;
    background-color: ${props => props.isActive ? "#6ba56b" : "transparent"};;

    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        transition: 0.2s;
        background-color: #6ba56b;
    }

    span:hover {
        transition: 0.2s;
        //filter: brightness(84%);
        //transform: translate(10px)
    }
`;

export const NameSpan = styled.span`
    padding: 10px 0;
    flex-grow: 1;
    height: 100%;
`;

export const CustomLightTrashIcon = styled(LightTrashIcon)`
    margin-right: 10px;
`;


export const CustomBasedModal = styled(BasedModal)`
    width: 250px;
    height: 350px;
`;

export const CustomPlusIcon = styled(PlusIcon)`
    cursor: pointer;

    :hover {
        filter: brightness(80%);
    }
`;

export const StyledCross = styled(CloseCross)`
    position: absolute;
    top: -32px;
    right: -55px;
    cursor: pointer;
    transition: transform 0.2s ease-in-out;

    :hover {
        transform: scale(1.05);
    }
`



